<template>
  <div
    class="broadcast"
    :class="{ selected }"
  >
    <div class="toggle-select">
      <toggle-button
        :selected="selected"
        @toggle="toggleSelected"
      />
    </div>
    <img class="broadcast-logo" :src="logoUrl">
    <div
      v-if="broadcast.name"
      class="highlight"
    >
      {{ broadcast.name }}
    </div>
    <div
      v-else
      class="broadcast-id"
    >
      ID: {{ broadcast.id }}
    </div>
    <div>{{ broadcastType(broadcast) }}</div>
    <div>{{ broadcast.hasLiveData ? 'Yes' : 'No' }}</div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ToggleButton from '@/components/common/ToggleButton';

export default {
  name: 'BroadcastItem',
  components: {
    ToggleButton,
  },
  props: {
    broadcast: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('customMarket', ['isSelected', 'broadcastType']),
    logoUrl() {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return this.broadcast.logoUrl || require('@/assets/icon-logo-placeholder.svg');
    },
    selected() {
      return this.isSelected(this.broadcast.id);
    },
  },
  methods: {
    ...mapMutations('customMarket', ['selectBroadcast', 'unselectBroadcast']),
    toggleSelected(selected) {
      if (selected) {
        this.selectBroadcast(this.broadcast.id);
      } else {
        this.unselectBroadcast(this.broadcast.id);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/variables";

.broadcast {
  font-size: 17px;
  line-height: 21px;
  background-color: rgba(0,0,0,0.1);
  margin-bottom: 8px;

  .broadcast-logo {
    width: 42px;
    height: 42px;
    border-radius: 2px;
  }

  & .highlight {
    font-weight: $weight-black;
  }

  .broadcast-id {
    font-style: italic;
  }

  &.selected {
    background-color: #333333;
  }
}

.toggle-select {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
